import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class CustomDateAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null  {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[2], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[0], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (!date) {
      return null;
    }
    let year = date.year;
    if (year.toString().length < 4) {
      year += 2000;
    }
    return year + this.DELIMITER +
      (date.month < 10 ? '0' + date.month : date.month) + this.DELIMITER +
      (date.day < 10 ? '0' + date.day : date.day);
  }
}
